import script from "./Pregnancycontrol.vue?vue&type=script&setup=true&lang=js"
export * from "./Pregnancycontrol.vue?vue&type=script&setup=true&lang=js"

import "./Pregnancycontrol.vue?vue&type=style&index=0&id=3b25508c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b25508c"]])

export default __exports__